export const WELL_DIRECTORY_SERVICE_API_URL = '/well-directory-service/api/v2';
